import type { CSSProperties } from 'react'
import { useState } from 'react'
import { useInterval } from 'usehooks-ts'
import './ProgressBar.css'

interface ProgresBarProps {
  time: number //in seconds
  secondChance?: boolean
  showCounter?: boolean
  longerWait?: string
}

export const ProgressBar = ({ time, secondChance, showCounter, longerWait }: ProgresBarProps) => {
  const [currentTime, setCurrentTime] = useState(0)
  const [currentProgress, setCurrentProgress] = useState(0)
  const [countEnd, setCountEnd] = useState(false)
  const [chanceUsed, setChanceUser] = useState(false)

  function handleTimeCount() {
    setCurrentTime(currentTime + 1)
    setCurrentProgress((currentTime / time) * 100)

    if (currentTime === time) {
      if (secondChance && !chanceUsed) {
        setCurrentTime(0)
        setCurrentProgress(0)
        setChanceUser(true)
      } else {
        setCountEnd(true)
      }
    }
  }

  function format(time: number) {
    let seconds: number | string = time % 60
    let minutes: number | string = Math.floor(time / 60)
    minutes = minutes.toString().length === 1 ? '0' + minutes : minutes
    seconds = seconds.toString().length === 1 ? '0' + seconds : seconds
    return minutes + ':' + seconds
  }

  useInterval(
    () => {
      handleTimeCount()
    },
    !countEnd ? 1000 : null
  )

  return (
    <div className="progress-bar__container onboarding-progress-bar">
      {showCounter ? (
        <h2 className="progress-bar__counter onboarding-progress-bar-counter">
          {format(time - currentTime)}
        </h2>
      ) : (
        <></>
      )}
      <div className="progress-bar__bar-container onboarding-progress-bar__container">
        <div
          className="progress-bar__bar onboarding-progress-bar__bar"
          style={
            {
              '--pb-bar-width': `${currentProgress}%`,
            } as CSSProperties
          }
        />
      </div>
      {chanceUsed ? (
        <div className="progress-bar__info-message onboarding-progress-bar-info-message">
          {longerWait ? longerWait : 'It takes longer than usual, please wait couple more minutes'}
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}
